import { render, staticRenderFns } from "./Cacher.vue?vue&type=template&id=661a3835&"
import script from "./Cacher.vue?vue&type=script&lang=js&"
export * from "./Cacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports